import React from 'react'

import { Card, CardContent, Typography, Box } from '@material-ui/core'

import useStyles from './styles'

const ResponseEmailCard = ({ text, content, img }) => {
  const classes = useStyles()
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Typography variant="h3" align="center" className={classes.title}>
            {text}
          </Typography>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mb={3}
          >
            <img
              src={img}
              width={200}
              height={200}
              alt="Imagem de confirmação"
              className={classes.image}
            />
          </Box>
          <Typography
            variant="subtitle1"
            align="center"
            className={classes.title}
          >
            {content}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  )
}

export default ResponseEmailCard
